// extracted by mini-css-extract-plugin
module.exports = {"basic_add_form_style":"BasicAddForm_basic_add_form_style__3e1-F","form_content_with_error":"BasicAddForm_form_content_with_error__7u2yC"};